//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DiagrammingLibraryAuthor.js";
import "../no/Builder.js";
import "../DiagrammingLibraryAuthor/DiagrammingLibraryAuthor.SymbolConnectionPointBuilder.js";
let d=[[[1,"ConnectionPoint",0,"DiagrammingLibraryAuthor.SymbolConnectionPointBuilder",0]],[[[],"GetPortObject",{R_:{portObject:"DiagrammingLibraryAuthor.AttributeHolder"}},0,0],[["portID"],"SetPortID",{},1,0],[[],"GetPortID",{R_:{portID:''}},0,0],[["portDirection"],"SetDirection",{},1,0],[[],"GetDirection",{R_:{portDirection:''}},0,0],[["types"],"SetAllowedAttachmentTypes",{},1,0],[[],"GetAllowedAttachmentTypes",{R_:{types:''}},0,0],[[],"GetNumberAllowedConnections",{R_:{num:''}},0,0],[["num"],"SetNumberAllowedConnections",{},1,0]],[]];
SPLM.DiagrammingLibraryAuthor.SymbolPortBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DiagrammingLibraryAuthor.SymbolPortBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;